import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './vue-i18n'
import './registerServiceWorker'
import myMixin from './plugins/myMixins'  
import vuetify from './plugins/vuetify'
import JsonExcel from "vue-json-excel";
import VueApexCharts from 'vue-apexcharts'
import DetailsDialog from './components/Details.vue';
import DataTransform from './assets/class/DataTransform.js'
import { jwtDecode } from 'jwt-decode';
// console.log(process.env.VUE_APP_DEPLOYMENT)


Vue.config.productionTip = false
Vue.use(myMixin)
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
Vue.component("downloadExcel", JsonExcel);
Vue.component('details-dialog', DetailsDialog);
Vue.prototype.$url = window.location.origin;
Vue.prototype.$dataTransform = new DataTransform();
(Vue.prototype.$URL = "http://10.169.140.17:4567/"), 
new Vue({
  i18n,
  router,
  store,
  vuetify,
  data() {
    return {
      decryptedUser: null,
      decryptedSalesOffices: null
    }
  },
  render: h => h(App),
  created() {
    this.setupInactivityTimer();
  },
  methods: {
    setupInactivityTimer() {
      let timer;
      let duration = 120 * 60 * 1000 //2 hours
      const resetTimer = () => {
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          if(this.$route.fullPath != '/login'){
            this.logout()
          }
        }, duration);
      }

      window.addEventListener('mousemove', resetTimer)
      window.addEventListener('keydown', resetTimer)
      resetTimer()
    },


    logout() {
      this.$store.commit("STORE_USERINFO", null);
      this.$store.commit("STORE_SALESOFFICE", null)
      this.$store.commit("STORE_CHART_URL", null);
      this.$router.push("/login");
    },
    decryptAndSetUserInfo() {
      if (this.$store.state.userInfo) {
        const { idToken, tokenType, name, 'custom:emp_code': empCode, 'custom:user_category': category } = this.$store.state.userInfo
        this.decryptedUser = jwtDecode(idToken);
        this.decryptedUser.tokenType = tokenType + '/';
        this.decryptedUser.tokenHeader = {
            headers: {
                Authorization: idToken
            }
        }
        if(tokenType == 'dss'){
            this.decryptedUser.name = name,
            this.decryptedUser['custom:emp_code'] = empCode,
            this.decryptedUser['custom:user_category'] = category
        }
      }
    },


  },

  watch: {
    userInfo: {
      handler(newUserInfo) {
        if (newUserInfo !== null) {
          this.decryptAndSetUserInfo()
        }
      },
      immediate: true,
    },
  }
}).$mount('#app')
